<template>
    <SlideWrapper :moduleType="moduleType">
        <template v-slot:wrapper="slotProps">

            <section 
                v-bind="slotProps.attributes"
                :aria-hidden="slotProps.states.hidden.toString()" 
            >
                <component
                    v-for="(slide, x) in slides"
                    :ref="`slide-item-${x}`"
                    :is="'SlideItem'"
                    :titleTag="'h1'"
                    :key="'s-' + x"
                    :hasOutline="false"
                    :hasDiscoverPath="false"
                    :slide="slide"
                    :playing="slotProps.states.playing"
                />
            </section>

        </template>
    </SlideWrapper>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
import { recruitsConfig } from '@/router/module/shared'
import { browser, setup } from '@/mixins/main'
import { VERTICAL_SCROLL_PAGES } from '@/data/pages'

import { slidesBeforeEnter, slidesParallax } from '@/helpers/helperSlides'
// import { showSlidesStories, hideSlidesStories } from '@/helpers/helperStories'

import SlideWrapper     from '../SlideWrapper'
import SlideItem        from '../Slide/SlideItem'

const { titles, alias, duration } = recruitsConfig

export default {
    name: 'RecruitSlides',

    props: {
        source: String, 
        poster: String,
    },

    components: {
        SlideWrapper,
        SlideItem,
        // AsyncStories: () => import(/* webpackChunkName: "ui-async-stories" */ '../Story/Index')
    },

    mixins: [
        browser,
        setup,
    ],

    data: () => ({
        transitionName: '',
        moduleType: 'recruit',
    }),

    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.transitionName = 'load'

            slidesBeforeEnter.call(vm, alias, titles)
        })
    },

    deactivated() {
        this.$root.$off('show-stories')
        this.$root.$off('hide-stories')
    },
    
    activated() {
        // this.afterSlideActivated()

        // Stories
        this.$root.$on('show-stories', ({id, cb}) => {

            const i = id.id - 1 /*_*/
            this.$root.$emit('slide-recruit-progress', { 
                stage: i,
                onComplete: () => {
                    cb instanceof Function && cb()
                    // const site = this.getSlideSelectors()

                    // showSlidesStories.call(this, site, i)
                },
            })

        })

        // this.$root.$on('hide-stories', (immediate = false) => {

        //     const site = this.getSlideSelectors()

        //     hideSlidesStories.call(this, site, immediate)
        // })
    },

    methods: {
        getSlide( slide ) {
            const childData = this.$refs[`slide-item-${slide}`]
            const data = Array.isArray(childData) && childData[0]

            return data
        },
        getStage( slide ) {
            const { pathStage } = this.getSlide( slide )

            return pathStage
        },
        afterSlideActivated() {
            if ( this.isMobile() ) {
                return;
            }
            return setTimeout(() => {
                const delayMs = this.currentSlide === 2 ? 0 : 1600
                !this.activeElement && this.restorePageFocus('.is-active h1, .is-active h2', delayMs)
            }, 100)
        },
        afterSlideChange( slide, oldSlide ) {
            return setTimeout(() => {

                this.disableFocusables( slide )
                this.restorePageFocus('.is-active h1, .is-active h2', 1600)

                if (oldSlide === 1 && slide === 2 && this.getStage(oldSlide) === 6) {
                    return this.$root.$emit('slide-recruit-progress', { 
                        stage: 0,
                    })
                }
            }, 200)
        },
        ...mapMutations({
            setVisibleStories: 'setVisibleStories',
            slideNav: 'recruit/slideNav',
            slideSet: 'recruit/slideSet',
            storySet: 'recruit/storySet',
        })
    },

    computed: {
        ...mapGetters({
            user: 'user',
            stories: 'recruit/stories',
            slides: 'recruit/slides',
            currentSlide: 'recruit/currentSlide',
        })
    },
    
    watch: {
        async currentSlide( slide, oldSlide ) {
            const { path } = this.$route 

            if ( this.isMobile() || VERTICAL_SCROLL_PAGES.some(el => path.includes(el)) ) {
                return;
            }

            const slideParams = [slide, alias, titles, duration, (slide - oldSlide)]
            await slidesParallax.call(this, ...slideParams)
            
            this.afterSlideChange(slide, oldSlide)
            
        },
    }
}
</script>
